export const BRAND_LEARNING_SOURCE_PREFERENCE = [
    'instagram',
    'tiktok',
    'linkedin',
    'facebook',
    'website',
    'manual',
];
export const SUBJECT_CATEGORY_VALUES = [
    'product',
    'person',
    'space',
    'food',
    'flatlay',
    'scene',
    'quote-card',
];
//# sourceMappingURL=brand-learning.const.js.map